import Text from "ab-text";
import Link from "ab-link";
import ParagraphText from "ab-paragraph-text";

import "./profile.scss";

const Profile = ({
  title = "Marc Segarra",
  subtitle = "Chef Ejecutivo",
  image = "/images/05-marc-segarra-desk-x2.jpg",
  imagemobile = "/images/05-marc-segarra-mobile-x2.jpg",
  content,
  link = {
    title: "descúbre más",
    url: "/restaurantes-valladolid/marc-segarra-chef-abadia-retuerta-ledomaine",
  },
}) => {
  return (
    <div className="profile">
      <div>
        <Text element="h2" animated>
          {title}
        </Text>
        <Text element="span" className="title">
          {subtitle}
        </Text>
        <picture>
          <source
            srcSet={imagemobile?.mediaItemUrl || imagemobile}
            media="(max-width: 850px)"
          />
          <img src={image?.mediaItemUrl || image} loading="lazy" alt={title} />
        </picture>
      </div>

      <div>
        {content ? (
          <ParagraphText content={content} singleColumn />
        ) : (
          <>
            <Text element="p">
              Marc Segarra es el chef ejecutivo de Abadía Retuerta LeDomaine
              desde febrero de 2016 y junto a su equipo firma la propuesta
              gastronómica de los diferentes restaurantes del hotel y bodega.
            </Text>
            <Text element="p">
              Muy exigente consigo mismo, cada temporada intenta reinventarse,
              ir un paso más allá y dar lo mejor de él y de su equipo. Hoy por
              hoy, su cocina se define por la creatividad en torno a la
              tradición y el vínculo con el entorno y los productos de
              temporada.
            </Text>
            <Text element="p">
              Su mayor inspiración radica en la atmósfera y entorno de Abadía
              Retuerta LeDomaine. Segarra recurre a elementos como la
              naturaleza, el legado histórico y artístico, y la bodega para
              imprimir un estilo singular y propio en las recetas.
            </Text>
          </>
        )}

        {link ? (
          <Link prefetch={false} text={link.title} href={link.url} />
        ) : null}
      </div>
    </div>
  );
};

export default Profile;
